import axios from 'axios';
import { API_URL } from '../env';

const push = {
  /** The server's public key, or null when it isn't set up to send pushes. */
  key: async () => (await axios.get(`${API_URL}/push/key`)).data.public_key,
  subscribe: async (subscription) => {
    await axios.post(`${API_URL}/push/subscriptions`, subscription);
  },
  unsubscribe: async (endpoint) => {
    await axios.delete(`${API_URL}/push/subscriptions`, { data: { endpoint } });
  },
};

export default push;
